import { Config } from "@config/typeDefs";
export const config: Config = {
  householdSettings: {
    refreshInterval: CONFIG && typeof CONFIG.householdSettings === "object" && CONFIG.householdSettings && typeof CONFIG.householdSettings.refreshInterval === "number" ? CONFIG.householdSettings.refreshInterval : null
  },
  initialNotifyWhenHours: CONFIG && typeof CONFIG.initialNotifyWhenHours === "number" && CONFIG.initialNotifyWhenHours >= 0 && CONFIG.initialNotifyWhenHours < 24 ? CONFIG.initialNotifyWhenHours | 0 : 0
};
export default config;